import { gql } from '@apollo/client'

import { apolloClient } from './apolloClient'

export const organizationsListQuery = gql`
  query Organizations {
    Organization_list(first: 500, orderBy: [{ name: ASC }]) {
      items {
        id
        name
        displayName
      }
    }
  }
`

export const getOrganizations = async () => {
  const result = await apolloClient.query({
    query: organizationsListQuery,
  })

  return (result.data as any)?.Organization_list?.items ?? []
}
